import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import DefaultButton from 'components/DefaultButton';
import endImage from '_assets/register/End.svg';
import MaiaLogo from 'components/MaiaLogo';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: theme.spacing(5),
  },
  title: {
    fontStyle: 'italic',
    fontWeight: 700,
  },
  text: {
    marginTop: '5vh',
    marginRight: '10%',
    marginLeft: '10%',
  },
  image: {
    maxHeight: '400px',
    maxWidth: '400px',
    width: '35%',
  },
  tertiaryTitle: {
    color: theme.palette.tertiary.main,
  },
  secondaryTitle: {
    color: theme.palette.secondary.main,
  },
}));

const End = () => {
  const classes = useStyles();
  const history = useHistory();

  const SideComponent = () => (
    <Grid container direction='column' style={{ height: 'auto' }}>
      <Grid container item justifyContent='center'>
        <MaiaLogo />
      </Grid>

      <Grid container item alignItems='center' style={{ height: '80%' }}>
        <Box>
          <Typography className={classes.text} align='center' variant='h3'>
            C’est Fini !
          </Typography>
          <Typography className={classes.text} align='center' variant='h3'>
            Votre activité est en ligne.
          </Typography>
          <Typography className={classes.text} align='center' variant='h3'>
            Attendez maintenant la validation de vos pièces justificatives par notre équipe.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction='column' style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent='center'>
          <Typography className={classes.title} align='center' variant='h1'>
            SUPER VOUS AVEZ PARAMÉTRÉ <br /> VOTRE <br/><br/>
            <span className={classes.tertiaryTitle}>ENTREPRISE</span>
            <span className={classes.secondaryTitle}> !</span>
          </Typography>
        </Grid>

        <Grid container item alignItems='center' justifyContent='center' style={{ flexGrow: 1 }}>
          <img
            src={endImage}
            style={{ margin: '3em' }}
            alt='Fin'
            width={450}
          />
        </Grid>

        <Grid container item alignItems='flex-end' justifyContent='center' style={{ marginBottom: '16px' }}>
          <DefaultButton
            color='secondary'
            variant='contained'
            onClick={() => history.push(routes.home.root)}
          >
            Valider
          </DefaultButton>
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default End;
